import { Logger } from '@/idv2/utils/logger';
import { IdDocImageUploadError } from '../types';

type HandleFileUploadResult = { ok: true; file: File } | { ok: false; errors: IdDocImageUploadError[] };

type HandleFileUploadProps = {
  acceptedFileFormats: string[];
  files: FileList | File[] | null;
  location?: string;
};

const handleFileUpload = ({
  acceptedFileFormats,
  files,
  location = 'id-doc-photo-prompt',
}: HandleFileUploadProps): HandleFileUploadResult => {
  if (!files || files.length === 0) {
    Logger.warn('Image upload failed. No image files detected', { location });
    return { ok: false, errors: [IdDocImageUploadError.unknownUploadError] };
  }
  if (files.length > 1) {
    Logger.warn('Image upload failed. User attempted to upload multiple images', { location });
    return { ok: false, errors: [IdDocImageUploadError.multipleFilesError] };
  }
  const fileTypeAllowed = acceptedFileFormats.includes(files[0].type);
  if (!fileTypeAllowed) {
    Logger.warn(`Image upload failed. User attempted to upload an unsupported file format ${files[0].type}`, {
      location,
    });
    return { ok: false, errors: [IdDocImageUploadError.fileTypeNotAllowed] };
  }
  return { ok: true, file: files[0] };
};

export default handleFileUpload;
export type { HandleFileUploadResult };
